// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1s5I6","title":"Images45_title__3Zzo4","images":"Images45_images__2mwiN"};